module.exports = __webpack_public_path__ + "assets/alert-success-icon.8ba6f71b.svg";